import { RecommendModal } from './recommend-modal';

export { RecommendModal };
